//#region import libraries
import React, { useEffect, useState } from "react";
// drop down menu
import Select from "react-select";
//redux
import { useDispatch, useSelector } from "react-redux";
import { selectFirebaseInfo, selectFirebaseUser } from "_redux/slices/main-screen/user";
import {
    selectTimelineAppSettings,
    selectTimelineAppSettingsStatus,
    fetchTimelineAppSettings,
    updateTimelineAppSettings,
} from "_redux/slices/timeline/timeline-control";
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import { timelineRoles } from "../timeline-constants";

// constants
const viewAppTasksOptions = [
    { value: "1", label: "01" },
    { value: "2", label: "02" },
    { value: "5", label: "05" },
    { value: "10", label: "10" },
    { value: "all", label: "ALL" },
]
//#endregion

const TimelineAppSettings = () => {

    //#region redux
    const dispatch = useDispatch()
    const usedTheme = useSelector(selectUsedTheme);
    const dbUser = useSelector(selectFirebaseInfo);
    const timelineAppSettings = useSelector(selectTimelineAppSettings);
    const timelineAppSettingsStatus = useSelector(selectTimelineAppSettingsStatus);
    const firebaseUser = useSelector(selectFirebaseUser);

    const iata = dbUser?.details?.authority;

    //#endregion

    const [selfAllocationAccess, setSelfAllocationAccess] = useState([]);
    const [viewAppTasks, setViewAppTasks] = useState(null);
    const [allowAddPax, setAllowAddPax] = useState([]);
    const [allTasksVisibleRoles, setAllTasksVisibleRoles] = useState([]);

    useEffect(() => {
        (async () => {
            if (!iata) {
                return;
            }
            const response = await dispatch(fetchTimelineAppSettings(iata));
            if (response?.meta?.requestStatus === "fulfilled") {
                const tempSettings = response?.payload?.settings;
                setSelfAllocationAccess(tempSettings?.selfAllocationAccess?.map(role => formatSelectValue(role)));
                setViewAppTasks(viewAppTasksOptions?.find(option => option?.value === tempSettings?.viewAppTasks) ?? null);
                setAllowAddPax(tempSettings?.allowAddPax?.map(role => formatSelectValue(role)));
                setAllTasksVisibleRoles(Array?.isFullArray(tempSettings?.allTasksVisibleRoles) ? tempSettings?.allTasksVisibleRoles?.map(role => formatSelectValue(role)) : []);
            }
        })();
    }, [])

    const handleUpdateTimelineAppSettings = async (body) => {
        const response = await dispatch(updateTimelineAppSettings({
            iata: iata,
            body: {
                settings: body,
                userId: firebaseUser?.uid,
            }
        }));
        if (response?.meta?.requestStatus === "fulfilled") {
            dispatch(fetchTimelineAppSettings(iata));
        }
    };

    const formatSelectValue = (id) => {

        let tempRole = timelineRoles?.find(role => role?.value == id);
        if (tempRole) {
            return {
                value: tempRole?.value,
                label: tempRole?.label
            }
        } else {
            return null;
        }
    }

    const getSelectStyles = () => ({

        control: (base) => ({
            ...base,
            minWidth: "200px",
            borderRadius: "5px",
            zIndex: 3,
            backgroundColor: usedTheme.BACKGROUND_COLOR,
            borderColor: usedTheme.BORDER_COLOR,
            color: usedTheme.TEXT_COLOR,
        }),
        placeholder: (provided) => ({
            ...provided,
            color: usedTheme.TEXT_COLOR,
        }),
        singleValue: (provided) => ({
            ...provided,
            color: usedTheme.TEXT_COLOR,
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 4,
            backgroundColor: usedTheme.BACKGROUND_COLOR,
            borderColor: usedTheme.BORDER_COLOR,
            color: usedTheme.TEXT_COLOR
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused
                ? usedTheme.BORDER_COLOR
                : usedTheme.BACKGROUND_COLOR,
            color: usedTheme.TEXT_COLOR,
            cursor: 'pointer',
        }),

    })

    return (
        <div>

            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                        View App Tasks
                    </span>
                    <Select
                        value={viewAppTasks}
                        onChange={(selectedOption) => {
                            setViewAppTasks(selectedOption);
                            handleUpdateTimelineAppSettings({
                                viewAppTasks: selectedOption?.value ?? "all"
                            }
                            );

                        }}
                        options={viewAppTasksOptions}
                        placeholder="Choose a Number..."
                        styles={getSelectStyles()}
                    />
                </div>
                <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                    Select the number of tasks displayed for the employee in the app
                </span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                        All tasks visible roles
                    </span>
                    <Select
                        value={allTasksVisibleRoles}
                        onChange={(selectedOption) => {
                            setAllTasksVisibleRoles(selectedOption);
                        }}
                        isMulti={true}
                        closeMenuOnSelect={false}
                        onMenuClose={() => {
                            handleUpdateTimelineAppSettings({
                                allTasksVisibleRoles: Array?.isFullArray(allTasksVisibleRoles)
                                    ? allTasksVisibleRoles?.map(role => role?.value)
                                    : []
                            }
                            );
                        }}
                        options={timelineRoles?.map(role => ({ value: role.value, label: role.label }))}
                        placeholder="Choose a Role..."
                        styles={getSelectStyles()}
                    />
                </div>
                <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                    Select the roles that are allowed to view all tasks in the app
                </span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                        Self Allocation access
                    </span>
                    <Select
                        value={selfAllocationAccess}
                        onChange={(selectedOption) => {
                            setSelfAllocationAccess(selectedOption)
                        }}
                        options={timelineRoles?.map(role => ({ value: role.value, label: role.label }))}
                        placeholder="Choose a Role..."
                        styles={getSelectStyles()}
                        isClearable
                        isMulti={true}
                        onMenuClose={() => {
                            handleUpdateTimelineAppSettings({
                                selfAllocationAccess: Array?.isFullArray(selfAllocationAccess)
                                    ? selfAllocationAccess?.map(role => role?.value)
                                    : []
                            }
                            );

                        }}
                        closeMenuOnSelect={false}
                    />
                </div>
                <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                    Select the self allocation access for the employee roles
                </span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                        Allow Add Pax
                    </span>
                    <Select
                        value={allowAddPax}
                        onChange={(selectedOption) => {
                            setAllowAddPax(selectedOption)
                        }}
                        options={timelineRoles?.map(role => ({ value: role.value, label: role.label }))}
                        placeholder="Choose a Role..."
                        styles={getSelectStyles()}
                        isClearable
                        isMulti={true}
                        onMenuClose={() => {
                            handleUpdateTimelineAppSettings({
                                allowAddPax: Array?.isFullArray(allowAddPax)
                                    ? allowAddPax?.map(role => role?.value)
                                    : []
                            }
                            );

                        }}
                        closeMenuOnSelect={false}
                    />
                </div>
                <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                    Select the roles that are allowed to add pax
                </span>
            </div>
        </div>
    )
}

export default TimelineAppSettings
